import { prefix } from '../api.config'

export const name = 'business-api-config'

export const api = {
  qrcode: {
    createInvoice: `${prefix}/api/v2/agent/mobile/settlement/add`, // post 新增订单
    getOrderInfo: `${prefix}/api/v2/agent/mobile/settlement/query-by-id`, // get 根据结算单id获取订单信息
    invoice: `${prefix}/api/v2/agent/mobile/settlement/invoice`, // post 保存信息并开票
    getSmartTitle: `${prefix}/api/v2/agent/invoice/titleMatch`, // get 根据结算单id获取订单信息
    getInvoiceBySettlementId: `${prefix}/api/v2/agent/mobile/proof/query-by-settlement`, // get 根据结算单id获取开票发票信息
    addWaitTitle: `${prefix}/api/v2/agent/wait/title/add`, // post 购方扫码提交抬头信息，供后台开票
    getSelementIdById: `${prefix}/api/v2/agent/wait-invoice/info` // get 根据Id查询selementid 后端 柠檬
  }
}
